import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { Poi } from '../Poi/poi.js';

const PoiGroup = props => {
  const {
    item
  } = props;
  const classNames = getClassNames('llm__pois');
  return jsx("div", {
    className: classNames,
    children: item.items.map((item, i) => jsx(Poi, Object.assign({}, props, {
      item: item
    }), i))
  });
};

export { PoiGroup };
//# sourceMappingURL=poi-group.js.map
